<template>
  <div class="mb-3">
    <label
      v-if="label"
      :for="id || undefined"
      class="form-label"
    >{{ label }}</label>
    <div
      v-if="hasAppend || hasPrepend"
      class="input-group"
    >
      <slot name="prepend" />
      <span
        v-if="hasPrepend"
        class="input-group-text"
      >
        <slot name="prepend-content" />
      </span>
      <CFormInput
        :id="id || undefined"
        :model-value="currentValue"
        :type="type"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        :class="addInputClasses"
        :invalid="!!invalidFeedback"
        :disabled="disabled"
        :readonly="readonly"
        @update:model-value="handleChange"
      />
      <slot name="append" />
      <span
        v-if="hasAppend"
        class="input-group-text"
      >
        <slot name="append-content" />
      </span>
    </div>
    <CFormInput
      v-else
      :id="id || undefined"
      :model-value="currentValue"
      :type="type"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :class="addInputClasses"
      :invalid="!!invalidFeedback"
      :disabled="disabled"
      :readonly="readonly"
      @update:model-value="handleChange"
    />
    <div
      v-if="validFeedback"
      class="valid-feedback d-block"
    >
      {{ validFeedback }}
    </div>
    <div
      v-if="invalidFeedback"
      class="invalid-feedback d-block"
    >
      {{ invalidFeedback }}
    </div>
  </div>
</template>

<script>
import { CFormInput } from '@coreui/vue-pro'

export default {
  name: 'CInput',
  components: { CFormInput },
  props: {
    modelValue: { type: [String, Number, File], default: '' },
    value: { type: [String, Number, File], default: '' },
    placeholder: { type: String, default: '' },
    type: { type: String, default: 'text' },
    label: { type: String, default: '' },
    addInputClasses: { type: [String, Object, Array], default: '' },
    invalidFeedback: { type: String, default: '' },
    validFeedback: { type: String, default: '' },
    disabled: Boolean,
    readonly: Boolean,
    size: { type: String, default: '' },
    id: { type: String, default: '' },
    autocomplete: { type: String, default: '' },
    plainText: Boolean,
  },
  emits: ['update:modelValue', 'update:value', 'input', 'change'],
  computed: {
    currentValue() {
      return this.modelValue !== undefined && this.modelValue !== ''
        ? this.modelValue
        : this.value
    },
    hasAppend() {
      return this.$slots['append-content'] || this.$slots['append']
    },
    hasPrepend() {
      return this.$slots['prepend-content'] || this.$slots['prepend']
    },
  },
  methods: {
    handleChange(val) {
      this.$emit('update:modelValue', val)
      this.$emit('update:value', val)
      this.$emit('input', val)
      this.$emit('change', val)
    },
  },
}
</script>
